let mlb_styles = {
    woman: [
        {
            category: "tshirt",
            imgRef: "MW_Poitou",
            en: [
                "Le Poitou",
                "Straight cut",
                "Crewneck",
                "Fitted sleeves",
                "Rolled short sleeves",
                "150 g",
            ],
            fr: [
                "Le Poitou",
                "Coupe droite",
                "Encolure ronde",
                "Emmanchures ajustées",
                "Manches courtes à revers",
                "150 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MW_ColombierManchesCourtes",
            en: [
                "La Colombier",
                "Slim fit",
                "Boatneck",
                "Fitted sleeves",
                "Rolled short sleeves",
                "230 g",
            ],
            fr: [
                "La Colombier",
                "Coupe ajustée",
                "Encolure bateau",
                "Emmanchures ajustées",
                "Manches courtes à revers",
                "230 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MW_ColombierManchesLongues",
            en: [
                "La Colombier",
                "Slim fit",
                "Boatneck",
                "Fitted sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "La Colombier",
                "Coupe ajustée",
                "Encolure bateau",
                "Emmanchures ajustées",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MW_Montpar",
            en: [
                "La Montpar",
                "Loose fit",
                "Crewneck",
                "Overcut sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "La Montpar",
                "Coupe ample",
                "Encolure ronde",
                "Emmanchures tombantes",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "sweater",
            imgRef: "MW_Choiseul",
            en: [
                "Le Choiseul",
                "Straight cut",
                "Crewneck",
                "Overcut sleeves",
                "Long sleeves",
                "Gauge 7",
            ],
            fr: [
                "Le Choiseul",
                "Coupe droite",
                "Encolure ronde",
                "Emmanchures tombantes",
                "Manches Longues",
                "Gauge 7",
            ],
        },
        {
            category: "shirt",
            imgRef: "MW_SaintGer",
            en: [
                "La Saint-Ger",
                "Loose fit",
                "Button-down collar",
                "Overcut sleeves",
                "Long sleeves",
                "120 g",
            ],
            fr: [
                "La Saint-Ger",
                "Coupe ample",
                "Encolure boutonnée chemise",
                "Emmanchures tombantes",
                "Manches longues",
                "120 g",
            ],
        },
        {
            category: "tshirt",
            imgRef: "MW_Chateau",
            en: [
                "Le Château",
                "Straight cut",
                "V-neck",
                "Kimono sleeves",
                "Rolled short sleeves",
                "140 g",
            ],
            fr: [
                "Le Château",
                "Coupe droite",
                "Encolure en V",
                "Emmanchures kimono",
                "Manches courtes à revers",
                "140 g",
            ],
        },
        {
            category: "shirt",
            imgRef: "MW_Temple",
            en: [
                "La Temple",
                "Straight cut",
                "Button-down collar",
                "Overcut sleeves",
                "Long sleeves",
                "120 g",
            ],
            fr: [
                "La Temple",
                "Coupe droite",
                "Encolure boutonnée chemise",
                "Emmanchures tombantes",
                "Manches longues",
                "120 g",
            ],
        },
        {
            category: "tshirt",
            imgRef: "MW_Sedaine",
            en: [
                "Le Sedaine",
                "Loose fit",
                "Crewneck",
                "Overcut sleeves",
                "Rolled short sleeves",
                "140 g",
            ],
            fr: [
                "Le Sedaine",
                "Coupe ample",
                "Encolure ronde",
                "Emmanchures tombantes",
                "Manches courtes à revers",
                "140 g",
            ],
        },
        {
            category: "tshirt",
            imgRef: "MW_SaintMich",
            en: [
                "Le Saint-Mich",
                "Straight cut",
                "Crewneck",
                "Fitted sleeves",
                "Short sleeves",
                "200 g",
            ],
            fr: [
                "Le Saint-Mich",
                "Coupe droite",
                "Encolure ronde",
                "Emmanchures ajustées",
                "Manches courtes à revers",
                "200 g",
            ],
        },
    ],
    man: [
        {
            category: "tshirt",
            imgRef: "MM_Poitou",
            en: [
                "Le Poitou",
                "Straight cut",
                "Crewneck",
                "Fitted sleeves",
                "Rolled short sleeves",
                "150 g",
            ],
            fr: [
                "Le Poitou",
                "Coupe droite",
                "Encolure ronde",
                "Manches ajustées",
                "Emmanchures courtes à revers",
                "150 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MM_ColombierManchesCourtes",
            en: [
                "La Colombier",
                "Straight cut",
                "Boatneck",
                "Fitted sleeves",
                "Short sleeves",
                "230 g",
            ],
            fr: [
                "La Colombier",
                "Coupe droite",
                "Encolure bateau",
                "Manches ajustées",
                "Emmanchures longues",
                "230 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MM_ColombierManchesLongues",
            en: [
                "La Colombier",
                "Straight cut",
                "Boatneck",
                "Fitted sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "La Colombier",
                "Coupe droite",
                "Encolure bateau",
                "Manches ajustées",
                "Emmanchures longues",
                "230 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MM_Montpar",
            en: [
                "La Montpar",
                "Loose fit",
                "Crewneck",
                "Overcut sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "La Montpar",
                "Coupe ample",
                "Encolure ronde",
                "Manches tombantes",
                "Emmanchures longues",
                "230 g",
            ],
        },
        {
            category: "sweater",
            imgRef: "MM_GrandCerf",
            en: [
                "Le Grand Cerf",
                "Straight cut",
                "Crewneck",
                "Overcut sleeves",
                "Long sleeves",
                "Gauge 7",
            ],
            fr: [
                "Le Grand Cerf",
                "Coupe droite",
                "Encolure ronde",
                "Manches tombantes",
                "Emmanchures longues",
                "Gauge 7",
            ],
        },
        {
            category: "sweatshirt",
            imgRef: "MM_Charonne",
            en: [
                "Le Charonne",
                "Straight cut",
                "Crewneck",
                "Raglan sleeves",
                "Long sleeves",
                "290 g",
            ],
            fr: [
                "Le Charonne",
                "Coupe droite",
                "Encolure ronde",
                "Manches raglans",
                "Emmanchures longues",
                "290 g",
            ],
        },
        {
            category: "sweatshirt",
            imgRef: "MM_Crozatier",
            en: [
                "Le Crozatier",
                "Straight cut",
                "Hooded",
                "Fitted sleeves",
                "Long sleeves",
                "290 g",
            ],
            fr: [
                "Le Crozatier",
                "Coupe droite",
                "Encolure à capuche",
                "Manches ajustées",
                "Emmanchures longues",
                "290 g",
            ],
        },
        {
            category: "shirt",
            imgRef: "MM_Malesherbes",
            en: [
                "La Malesherbes",
                "Straight cut",
                "Button-down collar",
                "Overcut sleeves",
                "Long sleeves",
                "120 g",
            ],
            fr: [
                "La Malesherbes",
                "Coupe droite",
                "Encolure boutonnée chemise",
                "Manches tombantes",
                "Emmanchures longues",
                "120 g",
            ],
        },
        {
            category: "shirt",
            imgRef: "MM_Rennes",
            en: [
                "La Rennes",
                "Straight cut",
                "Round Hem",
                "Mandarin Collar",
                "Long sleeves",
                "-",
            ],
            fr: [
                "La Rennes",
                "Coupe droite",
                "Liquette en bas de chemise",
                "Col Mao",
                "Emmanchures longues",
                "-",
            ],
        },
        {
            category: "jacket",
            imgRef: "MM_Amelot",
            en: [
                "L'Amelot",
                "Short jacket",
                "Teddy colar",
                "Raglan sleeves",
                "Long sleeves",
                "350 g",
            ],
            fr: [
                "L'Amelot",
                "Blouson court",
                "Col teddy",
                "Manches raglans",
                "Emmanchures longues",
                "350 g",
            ],
        },
        {
            category: "sweater",
            imgRef: "MM_Delepine",
            en: [
                "Le Delépine",
                "Straight cut",
                "Zipper collar",
                "Fitted sleeves",
                "Long sleeves",
                "Gauge 8",
            ],
            fr: [
                "Le Delépine",
                "Coupe droite",
                "Col camionneur zippé",
                "Manches ajustées",
                "Emmanchures longues",
                "Gauge 8",
            ],
        },
        {
            category: "tshirt",
            imgRef: "MM_Charlot",
            en: [
                "Le Charlot",
                "Straight cut",
                "Crewneck",
                "Fitted Sleeves",
                "Long sleeves",
                "150 g",
            ],
            fr: [
                "Le Charlot",
                "Coupe droite",
                "Encolure ronde",
                "Manches ajustées",
                "Emmanchures longues",
                "150 g",
            ],
        },
        {
            category: "tshirt",
            imgRef: "MM_Patureau",
            en: [
                "Le Patureau",
                "Straight cut",
                "Crewneck",
                "Fitted Sleeves",
                "Short sleeves",
                "170 g",
            ],
            fr: [
                "Le Patureau",
                "Coupe droite",
                "Encolure ronde",
                "Manches ajustées",
                "Emmanchures courtes",
                "170 g",
            ],
        },
    ],
    kid: [
        {
            category: "onesie",
            imgRef: "MK_CalmetteManchesCourtes",
            en: [
                "Le Calmette",
                "Straight cut",
                "Boatneck",
                "Fitted sleeves",
                "Short sleeves",
                "230 g",
            ],
            fr: [
                "Le Calmette",
                "Coupe droite",
                "Encolure Bateau",
                "Emmanchures ajustées",
                "Manches courtes",
                "230 g",
            ],
        },
        {
            category: "onesie",
            imgRef: "MK_CalmetteManchesLongues",
            en: [
                "Le Calmette",
                "Straight cut",
                "Boatneck",
                "Fitted sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "Le Calmette",
                "Coupe droite",
                "Encolure Bateau",
                "Emmanchures ajustées",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "onesie",
            imgRef: "MK_Malo",
            en: [
                "Le Malo",
                "Straight cut",
                "Crewneck",
                "Fitted sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "Le Malo",
                "Coupe droite",
                "Encolure ronde",
                "Emmanchures ajustées",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "tshirt",
            imgRef: "MK_Leon",
            en: [
                "Le Léon",
                "Straight cut",
                "Crewneck",
                "Fitted sleeves",
                "Short sleeves",
                "150 g",
            ],
            fr: [
                "Le Léon",
                "Coupe droite",
                "Encolure ronde",
                "Emmanchures ajustées",
                "Manches longues",
                "150 g",
            ],
        },
        {
            category: "sweatshirt",
            imgRef: "MK_Pereire",
            en: [
                "Le Pereire",
                "Straight cut",
                "Crewneck",
                "Overcut sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "Le Pereire",
                "Coupe droite",
                "Encolure ronde",
                "Emmanchures tombantes",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MK_GardetteManchesCourtes",
            en: [
                "La Gardette",
                "Slim fit",
                "Boatneck",
                "Fitted sleeves",
                "Short sleeves",
                "230 g",
            ],
            fr: [
                "La Gardette",
                "Coupe ajustée",
                "Encolure Bateau",
                "Emmanchures ajustées",
                "Manches courtes",
                "230 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MK_GardetteManchesLongues",
            en: [
                "La Gardette",
                "Slim fit",
                "Boatneck",
                "Fitted sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "La Gardette",
                "Coupe ajustée",
                "Encolure Bateau",
                "Emmanchures ajustées",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MK_Moulin",
            en: [
                "La Moulin",
                "Slim fit",
                "Crewneck",
                "Fitted sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "La Moulin",
                "Coupe ajustée",
                "Encolure ronde",
                "Emmanchures ajustées",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "onesie",
            imgRef: "MK_Morisot",
            en: [
                "Le Morisot",
                "Slim fit",
                "Crewneck",
                "Classic sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "Le Morisot",
                "Coupe ajustée",
                "Encolure ronde",
                "Emmanchures droites",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "onesie",
            imgRef: "MK_Dauphine",
            en: [
                "Le Dauphine",
                "Slim fit",
                "Crewneck",
                "Classic sleeves",
                "Long sleeves",
                "280 g",
            ],
            fr: [
                "Le Dauphine",
                "Coupe ajustée",
                "Encolure ronde",
                "Emmanchures droites",
                "Manches longues",
                "280 g",
            ],
        },
        {
            category: "onesie",
            imgRef: "MK_Blomet",
            en: [
                "Le Blomet",
                "Slim fit",
                "Peter Pan collar",
                "Classic sleeves",
                "Long sleeves",
                "280 g",
            ],
            fr: [
                "Le Blomet",
                "Coupe ajustée",
                "Col Claudine",
                "Emmanchures droites",
                "Manches longues",
                "280 g",
            ],
        },
        {
            category: "onesie",
            imgRef: "MK_Quintinie",
            en: [
                "Le Quintinie",
                "Straight cut",
                "Crewneck",
                "Fitted sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "Le Quintinie",
                "Coupe droite",
                "Encolure ronde",
                "Emmanchures ajustées",
                "Manches longues",
                "230 g",
            ],
        },
        {
            category: "sweatshirt",
            imgRef: "MK_Plantes",
            en: [
                "Le Plantes",
                "Loose fit",
                "Hooded",
                "Overcut sleeves",
                "Long sleeves",
                "290 g",
            ],
            fr: [
                "Le Plantes",
                "Coupe ample",
                "Encolure à capuche",
                "Emmanchures tombantes",
                "Manches longues",
                "290 g",
            ],
        },
        {
            category: "onesie",
            imgRef: "MK_Cain",
            en: [
                "Le Cain",
                "Slim fit",
                "Crossover V-neck",
                "Classic sleeves",
                "Long sleeves",
                "230 g",
            ],
            fr: [
                "Le Cain",
                "Coupe ajustée",
                "Encolure V croisée",
                "Emmanchures droites",
                "Manches longues",
                "230 g",
            ],
        },
    ],
    unisex: [
        {
            category: "sweatshirt",
            imgRef: "M_Reaumur",
            en: [
                "Le Réaumur",
                "Loose fit",
                "Hooded",
                "Overcut sleeves",
                "Long sleeves",
                "290 g",
            ],
            fr: [
                "Le Réaumur",
                "Coupe ample",
                "Encolure avec capuche",
                "Emmanchures tombantes",
                "Manches longues",
                "290 g",
            ],
        },
        {
            category: "sweatshirt",
            imgRef: "M_Troca",
            en: [
                "Le Troca",
                "Loose fit",
                "Hooded",
                "Overcut sleeves",
                "Long sleeves",
                "290 g",
            ],
            fr: [
                "Le Troca",
                "Coupe ample",
                "Encolure avec capuche",
                "Emmanchures tombantes",
                "Manches longues",
                "290 g",
            ],
        },
        {
            category: "tshirt",
            imgRef: "M_Popincourt",
            en: [
                "Le Popincourt",
                "Straight cut",
                "Crewneck",
                "Fitted sleeves",
                "Short sleeves",
                "180 g",
            ],
            fr: [
                "Le Popincourt",
                "Coupe droite",
                "Encolure ronde",
                "Emmanchures ajustées",
                "Manches courtes",
                "180 g",
            ],
        },
        {
            category: "sweatshirt",
            imgRef: "M_Ledru",
            en: [
                "Le Ledru",
                "Loose fit",
                "Crewneck",
                "Overcut sleeves",
                "Long sleeves",
                "290 g",
            ],
            fr: [
                "Le Ledru",
                "Coupe ample",
                "Encolure ronde",
                "Emmanchures tombantes",
                "Manches longues",
                "290 g",
            ],
        },
        {
            category: "sweatshirt",
            imgRef: "M_Placide",
            en: [
                "Le Placide",
                "Loose fit",
                "Zipped roll-neck",
                "Overcut sleeves",
                "Long sleeves",
                "290 g",
            ],
            fr: [
                "Le Placide",
                "Coupe ample",
                "Encolure avec col montant zippé",
                "Emmanchures tombantes",
                "Manches longues",
                "290 g",
            ],
        },
        {
            category: "jacket",
            imgRef: "M_Sebasto",
            en: [
                "La Sébasto",
                "Straight cut",
                "Button-down collar",
                "Overcut sleeves",
                "Long sleeves",
                "300 g",
            ],
            fr: [
                "La Sébasto",
                "Coupe droite",
                "Encolure boutonnée chemise",
                "Emmanchures tombantes",
                "Manches longues",
                "300 g",
            ],
        },
        {
            category: "sailor shirt",
            imgRef: "MM_ColombierManchesCourtes",
            en: [
                "La Colombier",
                "Straight cut",
                "Boatneck",
                "Fitted sleeves",
                "Short sleeves",
                "230 g",
            ],
            fr: [
                "La Colombier",
                "Coupe droite",
                "Encolure bateau",
                "Manches ajustées",
                "Emmanchures longues",
                "230 g",
            ],
        },
        {
            category: "shirt",
            imgRef: "MM_Breteuil",
            en: [
                "La Breteuil",
                "Loose fit",
                "Shirt collar",
                "Fitted sleeves",
                "Long sleeves",
                "100 g",
            ],
            fr: [
                "La Breteuil",
                "Coupe ample",
                "Col chemise",
                "Manches ajustées",
                "Emannchures longues",
                "100 g",
            ],
        },
    ],
};
